module.exports = __webpack_public_path__ + "static/media/doctor5.dcec4b0b.png";